import { ApplicationDto } from "model/Application";
import { useCallback, useEffect, useState } from "react";
import { Api } from "services/api/api.service";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const useGetGigApplications = (
  gigId?: string | number,
  fetchOnStartup: boolean = true
) => {
  const [companyState] = useCompanyStore();
  const [gigApplicationsData, setGigApplicationsData] =
    useState<ApplicationDto[]>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    if (fetchOnStartup) {
      fetch(gigId);
    }
  }, [gigId]);

  const fetch = useCallback(
    (gigId) => {
      if (!companyState.company || !gigId) return;

      setIsLoading(true);
      const id = typeof gigId === "string" ? parseInt(gigId) : gigId;
      Api()
        .company.application.getGigApplications(companyState.company.id, id)
        .then((res) => {
          let gigApplications: ApplicationDto[] = res.data;
          setGigApplicationsData(gigApplications);
        })
        .catch((e: any) => {
          setError(e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [companyState.company, gigId]
  );

  return [gigApplicationsData, isLoading, error, fetch] as const;
};
